export enum Routes {
  root = '/',
  addNewPaymentMethod = '/add-new-payment-method',
  deleteCardModal = '/delete-card-modal',
}

export const RoutesToPageTemplates = {
  [Routes.root]: 'index',
  [Routes.addNewPaymentMethod]: 'addNewCard',
  [Routes.deleteCardModal]: 'deleteCard',
} as const;
